import React from 'react';
import SettingsPage from '../../components/settings/SettingsPage';

const sections = [
    {
        key: 'general',
        titleEn: 'General',
        titleAr: 'عام',
        descriptionEn: 'Site name, email, phone, address and footer settings.',
        descriptionAr: 'اسم الموقع، البريد، الهاتف، العنوان وإعدادات التذييل.',
        fieldOrder: ['image', 'site_name', 'site_email', 'phone', 'address', 'footer_description'],
        alwaysShow: true,
    },
];

const GeneralSettings = () => (
    <SettingsPage
        titleEn="General Settings"
        titleAr="الإعدادات العامة"
        descriptionEn="Manage your site identity and contact information."
        descriptionAr="إدارة هوية الموقع ومعلومات الاتصال."
        sections={sections}
    />
);

export default GeneralSettings;
